if (!customElements.get('sanibra-gallery')) {
  customElements.define(
    'sanibra-gallery',
    class SanibraGallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
        this.thumbList = this.querySelector('[data-gallery-thumbs]');
        this.index = Math.max(
          0,
          this.slides.findIndex((slide) => !slide.hidden)
        );

        this.thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => this.show(index)));
        this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.index - 1));
        this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.index + 1));

        // Deslizar con el dedo sobre la imagen principal en móvil.
        const main = this.querySelector('.sanibra-gallery__main');
        main?.addEventListener('touchstart', (event) => (this.touchX = event.touches[0].clientX), { passive: true });
        main?.addEventListener(
          'touchend',
          (event) => {
            if (this.touchX == null) return;
            const deltaX = event.changedTouches[0].clientX - this.touchX;
            this.touchX = null;
            if (Math.abs(deltaX) > 40) this.show(this.index + (deltaX < 0 ? 1 : -1));
          },
          { passive: true }
        );

        // Opcional: al cambiar de pack, ir a la imagen de la variante.
        if (this.dataset.followVariant && typeof subscribe === 'function') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.followVariant) return;
            const mediaId = String(data.variant?.featured_media?.id || '');
            const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
            if (index >= 0) this.show(index);
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      show(requestedIndex) {
        const total = this.slides.length;
        if (!total) return;
        this.index = (requestedIndex + total) % total;

        this.slides.forEach((slide, index) => (slide.hidden = index !== this.index));
        this.thumbs.forEach((thumb, index) => {
          if (index === this.index) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        const activeThumb = this.thumbs[this.index];
        if (this.thumbList && activeThumb) {
          const left = activeThumb.offsetLeft - (this.thumbList.clientWidth - activeThumb.clientWidth) / 2;
          this.thumbList.scrollTo({ left, behavior: 'smooth' });
        }
      }
    }
  );
}
